<fa-icon
   class="sam-margin-right"
   *ngIf="callProgressState"
   [icon]="callProgressState.icon"
   [ngClass]="callProgressState.styleClass"
></fa-icon>
{{ callProgressState?.translationKey | translate | titlecase }}
